import * as MD from '@material-ui/core';
import * as React from 'react';
import { Component } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IConnectedReduxProps, IApplicationState } from '../Store'; // IApplicationState

import { login } from '../Store/User/Actions';

import { IUserState } from '../Store/User/Types';

import { Alert, AlertTitle } from '@material-ui/lab';
import Collapse from '@material-ui/core/Collapse';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ReplyRoundedIcon from '@material-ui/icons/ReplyRounded';
import { I18N } from '../Store/I18n/Types';

import { ILayoutState } from '../Store/Layout/Types';

//LOGOS
import TalkLightLogo from '../Assets/talk-light-logo.png';
import TalkDarkLogo from '../Assets/talk-dark-logo.png';
import { PaletteMode } from '../Themes';
import { Config } from '../config';
import { setElectionPage } from '../Store/Elections/Actions';
import { TypedStorage } from '../Utils/TypedStorage';
import { EtudeType } from '../Store/Elections/Types';

interface IOwnState {
    username: string;
    password: string;
    open: boolean;
}

interface IPropsFromState {
    user: IUserState;
    i18n: I18N;
    router: RouteComponentProps<{}>;
    layout: ILayoutState;
}

interface IPropsFromDispatch {
    login: typeof login;
    setElectionPage: typeof setElectionPage
}

type AllProps =
    MD.WithTheme &
    MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch &
    RouteComponentProps<{}> &
    IConnectedReduxProps;

const styles = (theme:any) => MD.createStyles({
    button: {
        margin: theme.spacing(1),
        marginTop: 25
    },
    card: {
        marginTop: '0px',
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        height: '230px'
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        position: 'absolute',
        right: 400,
        top: 20,
    },
    media: {
        height: 140,
    },
    textField: {
        margin: 8,
    },
    avatarSmall: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        alignItems:'center',
        width: theme.spacing(3),
        height: theme.spacing(3),
    }, 
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        alignItems:'center',
        color:"white"
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      cardContent: {
          //position: 'absolute',
          top: '0px',
          right: '0px',
          backgroundColor: theme.palette.background.paper,
          width: '100%'
      },
      profileStyle: {
        color: theme.palette.text.primary,
        position:'absolute',
        top:'0px',
        right:'25px'
    },
    alert: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        position: 'absolute',
        right: 113,
        top: 97,
    },
});

export class LoginPage extends Component<AllProps, IOwnState> {
    public constructor(props: AllProps) {
        super(props);
        this.state = {
            password: '',
            username: '',
            open: true
        };
    }

    public render(): React.ReactNode {
        const { classes, user, layout, theme } = this.props;
        const { open } = this.state;
        
        return (
            <MD.Card className={classes.card}>
                <MD.CardActionArea>

                </MD.CardActionArea>
                <MD.Grid style={{position:'absolute', left:'40px'}}>
                </MD.Grid>
                
                <MD.CardContent className={classes.cardContent}>
                    <form
                        className={classes.form}
                        noValidate={true}
                        onSubmit={this.onSubmit.bind(this)}
                    >
                        <MD.Grid container spacing={1} alignItems="flex-end" >
                            <MD.Avatar className={classes.avatarSmall}>
                                <AccountCircleIcon />
                            </MD.Avatar>
                                <MD.Grid item>
                                <MD.TextField
                                    autoComplete='username'
                                    className={classes.textField}
                                    label={'Utilisateur'}
                                    onChange={this.onUsernameChange.bind(this)}
                                    value={this.state.username}
                                    InputLabelProps={{
                                        style:{
                                            color: theme.palette.text.primary,
                                            marginTop: '-6px'
                                        }
                                    }}
                                />
                            </MD.Grid>
                        </MD.Grid>
                        <MD.Grid style={{top: '65px'}}
                        container spacing={1} alignItems="flex-end">
                            <MD.Avatar className={classes.avatarSmall}>
                                <VpnKeyIcon />
                            </MD.Avatar>
                                <MD.Grid item>
                            <MD.TextField
                                autoComplete='off'
                                className={classes.textField}
                                label={'Mot de passe'}
                                onChange={this.onPasswordChange.bind(this)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        this.onSubmit();
                                    }
                                }}
                                type='password'
                                value={this.state.password}
                                InputLabelProps={{
                                    style:{
                                        color: theme.palette.text.primary,
                                        marginTop: '-6px',
                                        
                                    }
                                }}
                            />
                            </MD.Grid>
                        </MD.Grid>
                        <MD.Button
                            className={classes.button}
                            color='secondary'
                            onClick={this.onSubmit.bind(this)}
                            variant='contained'
                        >
                            {'Connexion'}
                        </MD.Button>
                        <MD.Grid item xs style={{textAlign:'end'}}>
                            <MD.Link target="_blank" href={`${Config.UsersUrl}/reset`} variant="body2">
                                    Mot de passe oublié ?
                            </MD.Link>
                        </MD.Grid>
                    </form>
                </MD.CardContent>
                { 
                    user.errorMessage !== null &&
                    <Collapse in={open} className={classes.alert}>
                        <Alert  onClose={() => { this.setState({open:false}) }}
                        style={{backgroundColor: 'rgb(253, 236, 234)', color: 'rgb(97, 26, 21)'}}
                        severity="error"
                        >
                        <AlertTitle>Erreur</AlertTitle>
                        <strong> {user.errorMessage.message}</strong>
                        </Alert>
                    </Collapse>
                }
                <MD.Button
                    aria-haspopup='true'
                    className={classes.profileStyle}
                    onClick={() => window.open('https://www.yacast.fr/fr/','_self')}
                >
                    <MD.Avatar className={classes.avatarSmall}>
                        <ReplyRoundedIcon />
                    </MD.Avatar>
                    <span title={this.props.i18n._('Return to yacast link')} >{'Yacast.fr'}</span>
                </MD.Button>
                <MD.Grid item sm={12} style={{position:'absolute', left:'140px', top:'20px', }}>
                    {
                        layout.theme === PaletteMode.DARK ?
                        <img src={TalkLightLogo} height={60} alt='talkLogo'/> :
                        <img src={TalkDarkLogo} height={60} alt='talkLogo'/>
                    }
                    
                </MD.Grid>
                <MD.Grid item sm={12} style={{position:'absolute', left:'230px', bottom:'60px' }}>
                    {/* <img src={footer} alt='footer'/> */}
                </MD.Grid>
            </MD.Card>
       );
    }
    private onUsernameChange(ev: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ username: ev.target.value });
    }

    private onPasswordChange(ev: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ password: ev.target.value });
    }

    private onSubmit() {
        if (this.props.user.errorMessage !== null) {
            this.setState({open: true})
        }
        
        const pathName = this.props.router.location.pathname;
        this.props.login(this.state.username, this.state.password);
        this.props.history.push('/dashboard'); 
        
        if (TypedStorage.get('etude', EtudeType.PLURALISME) === EtudeType.ELECTION) {
            this.props.setElectionPage(false);
        }
        return <Redirect to={pathName} />;
    }
}

const mapStateToProps = ({user, i18n, layout } : IApplicationState, ownProps: RouteComponentProps<{}>) => {
    return {
      user: user,
      i18n: i18n.i18n,
      router: ownProps,
      layout
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    login: (u: string, p: string) => dispatch(login(u, p)),
    setElectionPage: (checked: boolean) => dispatch(setElectionPage(checked)),

});

export const Login =
    connect(mapStateToProps, mapDispatchToProps)(
        MD.withTheme(MD.withStyles(styles)(LoginPage)),
    );
